import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Col, Form, Input, Modal, Row } from 'antd';
import { connect } from 'dva';
import styles from './styles.less';

const FormItem = Form.Item;

function CurrentPasswordModal(props) {
  const [visible, setVisible] = useState(props.visible);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.form.validateFields((err) => {
      if (!err) {
        props.onSuccess(props.form.getFieldValue('currentPassword'));
      }
    });
  };

  const closeModal = () => {
    const modal = Modal.confirm({
      title: props.intl.formatMessage({ id: 'Common.Attention' }),
      content: props.intl.formatMessage({ id: 'Common.DiscardChanges' }),
      okText: props.intl.formatMessage({ id: 'Common.Agree' }),
      onOk: () => {
        hide();
        modal.destroy();
      },
      cancelText: props.intl.formatMessage({ id: 'Common.Cancel' }),
      width: 500,
    });
  };

  const hide = async () => {
    setVisible(false);
    await props.onCancel();
  };

  return (
    <Modal
      title={props.intl.formatMessage({ id: 'Component.CurrentPasswordModal.Title' })}
      visible={visible}
      onCancel={closeModal}
      footer={null}
      destroyOnClose
      width={720}
    >
      <Form onSubmit={handleSubmit}>

        <FormItem label={<FormattedMessage id="Component.CurrentPasswordModal.FieldLabel" />}>
          {props.form.getFieldDecorator('currentPassword', {
            rules: [{
              required: true,
              message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
            }],
          })(
            <Input maxLength={255} type="password" autoComplete="new-password" />,
          )}
        </FormItem>

        <Row type="flex" gutter={6} className={styles.bottomActionWrapper}>
          <Col span={12}>
            <Button type="default" onClick={hide} style={{ width: '100%' }}>
              <FormattedMessage id={'Common.Cancel'} />
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              <FormattedMessage id={'Common.Save'} />
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

CurrentPasswordModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default connect((
  {
    app, loading,
  },
) => (
  {
    app, loading,
  }
))(injectIntl(Form.create()(injectIntl(CurrentPasswordModal))));



// WEBPACK FOOTER //
// ./src/components/CurrentPasswordModal/index.js